import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

function Beneficios() {
  return (
    <section id="beneficios">
      <div className="container-fluid">
        <div className="row">

          {/* Benefício 1 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-hand-holding-heart fa-5x"></i>
            <h3>Atendimento Humanizado</h3>
            <p className="text-cinza">
              Suporte próximo e personalizado com contadores especialistas para ajudar em todas as etapas do seu negócio.
            </p>
          </div>

          {/* Benefício 2 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-cloud fa-5x"></i>
            <h3>Acesso em Nuvem</h3>
            <p className="text-cinza">
              Gerencie sua empresa de onde estiver, com total segurança e praticidade, usando qualquer dispositivo com internet.
            </p>
          </div>

          {/* Benefício 3 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-chart-line fa-5x"></i>
            <h3>Painel Inteligente</h3>
            <p className="text-cinza">
              Visualize relatórios financeiros, fluxo de caixa, notas fiscais e muito mais de forma simples e eficiente.
            </p>
          </div>

          {/* Benefício 4 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-file-invoice-dollar fa-5x"></i>
            <h3>Cobrança Automatizada</h3>
            <p className="text-cinza">
              Gere cobranças com boleto, PIX e cartão de forma automática, com notificações e recorrência.
            </p>
          </div>

          {/* Benefício 5 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-lock fa-5x"></i>
            <h3>Segurança de Dados</h3>
            <p className="text-cinza">
              Dados criptografados, com backups automáticos e infraestrutura robusta para proteger sua empresa.
            </p>
          </div>

          {/* Benefício 6 */}
          <div className="col-lg-4 feature-box">
            <i className="icon fas fa-sync-alt fa-5x"></i>
            <h3>Integração Contábil</h3>
            <p className="text-cinza">
              Sua movimentação financeira se conecta automaticamente com a contabilidade, sem retrabalho.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Beneficios;
